import React from 'react';
import ReactEchartsCore from 'echarts-for-react/lib/core';
import echarts from 'echarts/lib/echarts';
import 'echarts/lib/component/title';

import 'echarts/lib/chart/bar';

import numeral from 'numeral';

/**
 * * 堆叠柱状图
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-09-10 
 * Version: 1.0
 * Modify log:
 */
function IndexComponent(props) {

    const { rem, dataSource } = props;

    let angleAxisData = dataSource.map(item => {
        return item.hjmc ? item.hjmc : '';
    });

    let AseriesData = dataSource.map(item => {
        return item.hjblrs ? item.hjblrs : 0;
    });

    //环节办理率
    let BseriesData = dataSource.map(item => {

        let percent = 0;
        if (item.zrs && item.zrs != 0) {
            let p = item.hjblrs / item.zrs * 100;
            if(p == 0 || p == 100) {
                percent =  numeral(p).format('0');
            } else {
                percent = numeral(p).format("0.00");
            }
        }

        return percent;
    });

    const option = {
        title: {
            text: '环节办理统计',
            textStyle: {
                color: '#05ffe3',
                fontSize: 0.18 * rem
            },
            itemGap: 20
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
        },
        xAxis: [
            {
                show: true,
                inverse: true,
                data: angleAxisData,
                axisLine: {
                    show: false
                },
                axisTick: {
                    show: false
                },
                axisLabel: {
                    color: '#fce412',
                    textStyle: {
                        fontSize:'100%',
                        lineHeight: '70',
                    },
                    formatter: function(params) {
                        console.log(params);
                        console.log(params);
                        var newParamsName = ''
                        var paramsNameNumber = params.length
                        var provideNumber = 6;
                        var rowNumber = Math.ceil(paramsNameNumber / provideNumber)
                        for (let row = 0; row < rowNumber;row++) {
                          newParamsName +=
                            params.substring(
                              row * provideNumber,
                              (row + 1) * provideNumber
                            ) + '\n'
                        }
                        return newParamsName;
                    }
                },
            },
            {
                show: true,
                inverse: true,
                data: BseriesData,
                axisLine: {
                    show: false
                },
                axisLabel: {
                    formatter: '{value} %',
                    textStyle: {
                        fontSize: 0.14 * rem,
                        color: '#00ffca'
                    }
                },
                axisTick: {
                    show: false
                },
                splitLine: {
                    show: false
                }
            }
        ],
        yAxis: {
            type: 'value',
            axisLine: {
                show: false
            },
            axisTick: {
                show: false
            },
            axisLabel: {
                show: false
            },
            splitLine: {
                show: false
            },
        },
        legend: {
            show: false,
            data: ['已办理', '未办理']
        },
        series: [
            {
                type: 'bar',
                data: AseriesData,
                name: '已办理',
                barMaxWidth: 0.24 * rem,
                barMinHeight: 1,
                itemStyle: {
                    normal: {
                        barBorderRadius: 0.05 * rem,
                        color: {
                            type: 'linear',
                            x: 0,
                            y: 1,
                            colorStops: [
                                {
                                    offset: 0,
                                    color: '#fce412'   // 0% 处的颜色
                                },
                                {
                                    offset: 1,
                                    color: '#00ffca'// 100% 处的颜色
                                }
                            ],
                            globalCoord: false // 缺省为 false
                        }
                    }
                }
            }
        ]
    };

    return (
        <div style={{ width: '100%', height: '100%' }}>
            <ReactEchartsCore
                style={{ width: '100%', height: '100%' }}
                echarts={echarts}
                option={option}
                notMerge={true}
                lazyUpdate={true}
            />
        </div>
    )

}

export default IndexComponent;


// WEBPACK FOOTER //
// ./containers/Show-bgy/LeftTopBox/_StackedBar.js